/**
 * 地图封装的地图实例
 */
/**
 * 地图封装的地图实例
 * @module Map
 */
'use strict';
define([
    '../g2',
    '../base/Class',
    '../utils/CommonUtil',
    '../utils/LayerUtil',
    '../misc/AppEvent',
    '../misc/AppEvents',
    '../layers/index'
], function (
    g2,
    Class,
    CommonUtil,
    LayerUtil,
    AppEvent,
    AppEvents,
    lys
) {
    /**
     * 一张图二维地图类
     * @constructor
     * @alias G.Map
     * @augments g2.carto.Map
     * @param {Object} options - 必填，构造参数
     * @param {String} options.targetId 必填，容器id
     * @param {Object} options.defaultExtent 必填，默认视野
     * @param {Object} options.fullExtent 可选，全图视野
     * @param {Boolean} options.initControlContainer - 可选，默认为false，是否初始化控件容器
     * @returns {G.Map} - 实例化的对象
     * @example
     * var opts={
     *       "targetId": "map", //map需要的容器div id
     *       "defaultExtent": {
     *           "zoom": 8,//初始级别
     *           "maxZoom": 20,//最大级别
     *           "minZoom": 0,//最小级别
     *           "center": [116.390833, 39.904832],//中心点
     *           "projection": "EPSG:4326"//坐标系
     *        },
     *        "fullExtent":{//全图配置
     *            "zoom":5,
     *            "center": [116.390833, 39.904832]
     *         }
     * }
     * var map=new G.Map(opts);
     */
    var emap = function (opts) {
        this.initialize(opts);
        //
        this.callInitHooks();
    }
    //super class
    var superClazz = g2.carto.Map;
    
    //define
    emap.prototype = {
        options: {},
        constructor: emap,
        initialize: function (options) {
            Class.setOptions(this, options);
            //兼容原有参数形式
            var mapOpts = this.options.mapOpts || this.options;
            //适配参数,level参数可配置为zoom
            if (!isNaN(mapOpts.defaultExtent.zoom)) {
                mapOpts.defaultExtent.level = mapOpts.defaultExtent.zoom;
            }
            if (mapOpts.fullExtent) {
                if (!isNaN(mapOpts.fullExtent.zoom)) {
                    mapOpts.fullExtent.level = mapOpts.fullExtent.zoom;
                }
            }
            //
            superClazz.call(this, mapOpts);
            //initialize
            if (mapOpts.targetId) { //如果指定容器，则默认初始化
                this.init({
                    targetId: mapOpts.targetId
                });
            }
            //
            this.id = mapOpts.targetId;
            //存储所有图层，key为图层id，value为图层对象
            this.layerSet = {};
            /**
             * 地图渲染完成的回调，可能会触发多次，慎用。
             */
            this.listen('postrender', function () {
                //去掉openlayer版权
                try {
                    var eles = document.getElementsByClassName('ol-attribution');
                    var ele = eles.length > 0 ? eles[0] : null;
                    if (ele != null) {
                        ele.parentElement.removeChild(ele);
                    }
                } catch (e) {}
            });
        },
        /**
         * @ignore
         * @param {any} opts
         */
        init(opts) {
            if (opts && opts.targetId) {
                this.options.targetId = opts.targetId;
            }
            superClazz.prototype.init.call(this, opts);
        },
        
        /**
         * 组件销毁的方法
         * @method
         */
        destroy: function () {
            //todo
            //clear layers
            //clear controls
            //clear div
            //clear events
        },
        callInitHooks: function () {
            if (this._initHooksCalled) {
                return;
            }
            this._initHooksCalled = true;
            for (var i = 0, len = this._initHooks.length; i < len; i++) {
                this._initHooks[i].call(this);
            }
        }
        
    }
    //copy properties
    Class.defaults(emap, Class, true);
    //inherits
    Class.inherits(emap, superClazz);
    /**
     * 公共方法
     */
    emap.include({
        /**
         * 获取地图对象，已经过时，暂时保留原有风格
         * @ignore
         * @method
         * @memberOf G.Map.prototype
         * @returns {Object} -G.Map,地图对象
         */
        getMap: function () {
            return this;
        },
        /**
         * @method
         * @memberOf G.Map.prototype
         * 初始化点线面图层组，用于控制点线面的展示层级
         */
        initialGroupLayers: function (groupLayerZIndexes) {
            LayerUtil.initGroupLayers(this, groupLayerZIndexes);
        },
        /**
         * 获取全局事件派发器
         * @method
         * @memberOf G.Map.prototype
         * @returns {G.misc.AppEvent}
         */
        getAppEvent: function () {
            if (!this._appEvent) {
                this._appEvent = new AppEvent({
                    map: this
                });
            }
            return this._appEvent;
        },
        /**
         * 更新地图尺寸
         * @ignore
         * @method
         * @memberOf G.Map.prototype
         */
        updateViewSize() {
            this.map.updateSize();
        },
        
        /**
         * 移动地图可视范围接口
         * @ignore
         * @method
         * @param PointList {Array} x,y数组
         * @param level {Number} 定位的级别
         */
        changeExtent: function (PointList, level) {
            var map = this.getMap();
            var centerPoint = new g2.sfs.Point({
                x: PointList[0],
                y: PointList[1],
                spatialReference: map.spatialReference
            })
            map.setCenter(centerPoint);
            map.zoomTo(parseInt(level));
        },
        /**
         * 清屏接口
         * @method
         * @memberOf G.Map.prototype
         * @param opts {Object} 可选
         * @param opts.filterFn {Function} 可选，与matchRegex、ignoreRegex三选一，自定义判断是否清除的方法，返回true清除，false不清除
         * @param opts.matchRegex {Array} 可选，正则表达式数组，与filterFn、ignoreRegex三选一，图层id匹配正则数组中任一一个的进行清除
         * @param opts.ignoreRegex {Array} 可选，正则表达式数组，与filterFn、matchRegex三选一，图层id匹配正则数组中任一一个的不进行清除
         * @example
         * //清空图层id不等于plot-layer的图层
         * map.clear({
         *    filterFn:function(layer){
         *        return layer.id!='plot-layer';
         *      }
         *    })
         * //只清空图层id为plot-layer的图层
         * map.clear({matchRegex:[/^plot-layer$/]});
         * //清空所有id不以plot或者data开头的图层
         * map.clear({ignoreRegex:[/^plot.*$/,/^data.*$/]});
         * //清空所有图层
         * map.clear();
         */
        clear: function (opts) {
            opts = opts || {};
            var layers = this.getMap().layers,
                filterFn = opts.filterFn || false,
                matchRegex = opts.matchRegex || false,
                ignoreRegex = opts.ignoreRegex || false;
            var handlerObj = {
                filterFn: function (layer, fn) {
                    if (fn(layer)) {
                        clearLayer.call(this, layer);
                    }
                },
                matchRegex: function (layer, matchRegex) {
                    if (regexMatch(layer.id, matchRegex)) {
                        clearLayer.call(this, layer);
                    }
                },
                ignoreRegex: function (layer, ignoreRegex) {
                    if (!regexMatch(layer.id, ignoreRegex)) {
                        clearLayer.call(this, layer);
                    }
                },
                all: clearLayer
            }
            /**
             * 派发全局事件
             *
             */
            this.fire(AppEvents.CLEAR_MAP);
            //清理图层
            for (var i = 0, len = layers.length; i < len; i++) {
                var layer = layers[i];
                if (layer) {
                    //不处理底图
                    if (layer._type == lys.TYPES.BASE_LAYER_TAG) {
                        continue;
                    }
                    if (CommonUtil.isFunction(filterFn)) {
                        handlerObj.filterFn.call(this, layer, filterFn);
                    } else if (CommonUtil.isArray(matchRegex)) {
                        handlerObj.matchRegex.call(this, layer, matchRegex);
                    } else if (CommonUtil.isArray(ignoreRegex)) {
                        handlerObj.ignoreRegex.call(this, layer, ignoreRegex);
                    } else {
                        //默认清理所有业务图层
                        handlerObj.all.call(this, layer);
                    }
                }
            }
            
            function regexMatch(id, regexs) {
                var match = false;
                if (regexs && regexs.length > 0) {
                    for (var i = 0, len = regexs.length; i < len; i++) {
                        var reg = regexs[i];
                        if (reg instanceof RegExp) {
                            if (reg.test(id)) {
                                match = true;
                                break;
                            }
                        }
                    }
                }
                return match;
            }
            
            function clearLayer(layer) {
                if (layer instanceof g2.carto.GroupLayer) {
                    var lys = layer.groupLayers;
                    for (var k = 0, len = lys.length; k < len; k++) {
                        var ly = lys[k];
                        clearLayer.call(this, ly);
                    }
                } else if (layer) {
                    layer.clear();
                }
            }
        },
        /**
         * 添加图层，重写g2.carto.Map的方法
         * @override
         * @method
         * @param  layer {g2.lys.Layer/G.lys.BaseLayer} 必填，图层
         */
        addLayer: function (layer) {
            var temp = layer;
            if (temp instanceof lys.BaseLayer) {
                temp = layer.getLayer();
                superClazz.prototype.addLayer.call(this, temp);
                temp._maxZoom && temp.setMaxZoom(temp._maxZoom);
                this.layerSet[layer.id] = layer;
            } else if (CommonUtil.isArray(temp)) {
                temp.forEach(l => {
                    superClazz.prototype.addLayer.call(this, l);
                    l._maxZoom && l.setMaxZoom(l._maxZoom);
                    l._minZoom && l.setMinZoom(l._minZoom);
                    this.layerSet[l.id] = l;
                })
            } else {
                superClazz.prototype.addLayer.call(this, layer);
                if (layer.groupLayers){
                    layer.groupLayers.forEach(l=>{
                        l._maxZoom && l.setMaxZoom(l._maxZoom);
                        l._minZoom && l.setMinZoom(l._minZoom);
                    })
                }else{
                    layer._maxZoom && layer.setMaxZoom(layer._maxZoom);
                    layer._minZoom && layer.setMinZoom(layer._minZoom);
                }
                
                this.layerSet[layer.id] = layer;
            }
            
            //记录所有添加的原始图层
            
            //全局通知
            this.fire(AppEvents.LAYER_CHANGED, {
                type: 'add',
                layers: [layer]
            });
        },
        /**
         * 移除图层，重写g2.carto.Map的方法
         * @override
         * @method
         * @param  layer {g2.lys.Layer/G.lys.BaseLayer} 必填，图层
         */
        removeLayer: function (layer) {
            var temp = layer;
            if (temp instanceof lys.BaseLayer) {
                temp = layer.getLayer();
            }
            superClazz.prototype.removeLayer.call(this, temp);
            //删除记录的图层
            this.layerSet[layer.id] = null;
            delete this.layerSet[layer.id];
            //全局通知
            this.fire(AppEvents.LAYER_CHANGED, {
                type: 'remove',
                layers: [layer]
            });
        },
        /**
         * 根据id获取图层
         * @method
         * @param layerId {String} 必填，图层id
         * @returns {g2.lys.Layer}
         */
        getLayerById: function (id) {
            //先从图层记录中获取
            if (this.layerSet.hasOwnProperty(id)) {
                return this.layerSet[id];
            }
            return LayerUtil.getLayerById(this, id);
        }
    });
    /**
     * 控件相关
     */
    emap.include({
        /**
         * 添加比例尺控件
         * @ignore
         * @method
         * @memberOf G.Map.prototype
         * @param opts {Object} 可选
         * @param opts.className {String}　可选，控件的样式名，默认为ol-scale-line
         */
        addScaleLineCtrl: function (className) {
            opts = opts || {};
            var className = opts.className || 'ol-scale-line';
            /**
             * 临时使用tsgis的比例尺控件
             */
            this.getMap().addScaleLineControl(className);
            //保存class 为移除用
            this._scaleLineCtrlClass = className;
        },
        /**
         * 移除比例尺控件
         * @ignore
         * @method
         * @memberOf G.Map.prototype
         */
        removeScaleLineCtrl: function () {
            //tsgis map暂时无removeControl接口，暂使用样式移除
            jQuery('#' + this.id).fin('.ol-overlaycontainer-stopevent .' + this._scaleLineCtrlClass).remove();
        }
    });
    
    /**
     * 事件相关
     * 2019年10月25日 取消地图事件修改
     */
    //保留tsgis原有map 的on un方法,取别名
    // var prototype = emap.prototype;
    // prototype['_g2_on'] = prototype['on'];
    // delete prototype['on'];
    // prototype['_g2_un'] = prototype['un'];
    // delete prototype['un'];
    /**
     * 保留地图的事件机制
     */
    emap.include({
        /**
         * 绑定地图事件
         * @method
         * @memberOf G.Map.prototype
         * @param event {String} 必填，事件名；
         * click=鼠标点击，dblclick=鼠标双击，mousemove=鼠标移动，mousedown=鼠标落下，mouseup=鼠标弹起
         * extentchanged=视野改变，resolutionchanged=比例尺改变，resize=地图尺寸改变
         * @param callback {Function} 必填，监听方法
         * @param context {Object} 可选，监听方法上下文
         */
        listen: function (event, callback, context) {
            var isMapEvent = this.getAppEvent().isMapEvent(event);
            //如果是地图事件，走代理
            if (isMapEvent) {
                this.getAppEvent()._on(event, callback, context);
            } else { //如果是自定义事件
                AppEvent.prototype.on.call(this, event, callback, context);
            }
            
        },
        /**
         * 取消绑定地图事件
         * @method
         * @memberOf G.Map.prototype
         * @param event {String} 必填，事件名
         * @param callback {Function} 必填，监听方法
         * @param context {Object} 可选，监听方法上下文
         */
        off: function (event, callback, context) {
            var isMapEvent = this.getAppEvent().isMapEvent(event);
            //如果是地图事件，走代理
            if (isMapEvent) {
                this.getAppEvent()._off(event, callback, context);
            } else { //如果是自定义事件
                AppEvent.prototype.off.call(this, event, callback, context);
            }
        },
        fire: function () {
            AppEvent.prototype.fire.apply(this, arguments);
        },
        once: function () {
            AppEvent.prototype.once.apply(this, arguments);
        }
    });
    /**
     * 适配egis与g2
     * @ignore
     */
    emap.include({
        //获取地图中心
        _getMapCenter: function () {
            let _center = this.getCenter();
            if (!(CommonUtil.isArray(_center))) {
                return [_center.x, _center.y];
            } else {
                return _center;
            }
        },
    });
    return emap;
});